/*eslint-disable*/
import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
// core components
import styles from "assets/jss/material-kit-react/views/componentsSections/downloadStyle.js";

const useStyles = makeStyles(styles);

export default function SectionDownload() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <GridContainer className={classes.textCenter} justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <h2 className={classes.title}>Téléchargez l'Application ChiNcoDrive et mettez un Taxi dans votre poche</h2>
            <img className={classes.triobanner} src={"http://chincotrac.com/chincodrive/triobanner.png"} alt="ChiNcoDrive App Banner" />
            <h4 className={classes.description}>ChiNcoDrive - Commandez un taxi via votre smartphone, partout et à tout moment !</h4>
          </GridItem>
          <GridItem xs={12} sm={8} md={6}>
            <a href="https://play.google.com/store/apps/details?id=com.chincotec.drivesharing"><img src="http://chincotrac.com/chincodrive/playstore.png" alt="ChiNcoDrive Share Playstore Link"/></a>
            <span style={{marginRight: '5px'}}></span>
            <a href="https://play.google.com/store/apps/details?id=com.chinco.driverapp"><img src="http://chincotrac.com/chincodrive/playstore.png" alt="ChiNcoDrive Playstore Link"/></a>
          </GridItem>
        </GridContainer>

      </div>
    </div>
  );
}
